import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular';

@Component({
    selector: 'app-default-footer',
    templateUrl: './default-footer.component.html',
    styleUrls: ['./default-footer.component.scss'],
    standalone: false
})
export class DefaultFooterComponent extends FooterComponent {
  currentYear = new Date().getFullYear();

  constructor() {
    super();
  }
}
